import { render, staticRenderFns } from "./tablaCategorias.vue?vue&type=template&id=385f6004&scoped=true&"
import script from "./tablaCategorias.vue?vue&type=script&lang=js&"
export * from "./tablaCategorias.vue?vue&type=script&lang=js&"
import style0 from "./tablaCategorias.vue?vue&type=style&index=0&id=385f6004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f6004",
  null
  
)

export default component.exports